module.exports = __webpack_public_path__ + "img/logo1_m.80b1fd83.png";